"use strict";
exports.__esModule = true;
var React = require("react");
var Linkify = require("linkifyjs/react");
function splitMessage(message) {
    var breakIndex = message.indexOf('\n');
    // consider that there can be line without a break
    if (breakIndex === -1) {
        return message;
    }
    return message.substr(0, breakIndex);
}
function ErrorPanel(_a) {
    var error = _a.error;
    /* This checks for error logTypes and shortens the message in the console by wrapping
    it a <details /> tag and putting the first line in a <summary /> tag and the other lines
    follow after that. This creates a nice collapsible error message */
    var otherErrorLines;
    var firstLine = splitMessage(error);
    var msgArray = error.split('\n');
    if (msgArray.length > 1) {
        otherErrorLines = msgArray.slice(1);
    }
    if (!otherErrorLines) {
        return React.createElement(Linkify, null, error);
    }
    return (React.createElement("details", null,
        React.createElement("summary", { style: { outline: 'none', cursor: 'pointer' } }, firstLine),
        React.createElement(Linkify, null, otherErrorLines.join('\n\r'))));
}
exports["default"] = ErrorPanel;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRXJyb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvQ29tcG9uZW50L21lc3NhZ2UtcGFyc2Vycy9FcnJvci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSw2QkFBOEI7QUFDOUIseUNBQTBDO0FBRTFDLFNBQVMsWUFBWSxDQUFDLE9BQWU7SUFDbkMsSUFBTSxVQUFVLEdBQUcsT0FBTyxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQTtJQUN4QyxrREFBa0Q7SUFDbEQsSUFBSSxVQUFVLEtBQUssQ0FBQyxDQUFDLEVBQUU7UUFDckIsT0FBTyxPQUFPLENBQUE7S0FDZjtJQUNELE9BQU8sT0FBTyxDQUFDLE1BQU0sQ0FBQyxDQUFDLEVBQUUsVUFBVSxDQUFDLENBQUE7QUFDdEMsQ0FBQztBQUVELFNBQVMsVUFBVSxDQUFDLEVBQTRCO1FBQTFCLEtBQUssV0FBQTtJQUN6Qjs7dUVBRW1FO0lBQ25FLElBQUksZUFBZSxDQUFBO0lBQ25CLElBQU0sU0FBUyxHQUFHLFlBQVksQ0FBQyxLQUFLLENBQUMsQ0FBQTtJQUNyQyxJQUFNLFFBQVEsR0FBRyxLQUFLLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQyxDQUFBO0lBQ2xDLElBQUksUUFBUSxDQUFDLE1BQU0sR0FBRyxDQUFDLEVBQUU7UUFDdkIsZUFBZSxHQUFHLFFBQVEsQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUE7S0FDcEM7SUFFRCxJQUFJLENBQUMsZUFBZSxFQUFFO1FBQ3BCLE9BQU8sb0JBQUMsT0FBTyxRQUFFLEtBQUssQ0FBVyxDQUFBO0tBQ2xDO0lBRUQsT0FBTyxDQUNMO1FBQ0UsaUNBQVMsS0FBSyxFQUFFLEVBQUUsT0FBTyxFQUFFLE1BQU0sRUFBRSxNQUFNLEVBQUUsU0FBUyxFQUFFLElBQ25ELFNBQVMsQ0FDRjtRQUNWLG9CQUFDLE9BQU8sUUFBRSxlQUFlLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFXLENBQ3pDLENBQ1gsQ0FBQTtBQUNILENBQUM7QUFFRCxxQkFBZSxVQUFVLENBQUEifQ==